/** @module MaterialSpec/GenerateColorRuleForMaterial **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

return declare(Controller, {
		/**
		 * @override
		 * Query to back end to generate ColorMatching Rules For material
		 */
		process: function() {
			const req = this.m_action.m_request;
			
			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("ParentURL", this.m_urlParent)
				.addParameter("URL", this.m_urlNode)
				.addParameter("GenerateFromAvailability", true)
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}

	});
});